import React from "react";
import Icons from "../components/icon/icons.svg"; // Path to your icons.svg
import PropTypes from "prop-types";

const Icon = ({
    name,
    color,
    size,
    customClassName,
    containerClass,
    labelClass,
    labelValue,
    onClick,
    hidden
}) => (
    <div hidden={hidden} className={containerClass} onClick={onClick}>
        <svg
            className={`icon icon-${name} ${customClassName}`}
            color={color}
            width={size}
            height={size}
        >
            <use xlinkHref={`${Icons}#${name}`} />
        </svg>
        <span className={labelClass}>{labelValue}</span>
    </div>
);

Icon.propTypes = {
    name: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.string,
    customClassName: PropTypes.string,
};

export default Icon;
